<template>
  <div>
    <div class="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      <div
        v-for="(goods, index) in products"
        :key="index"
        class="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
        @click="$emit('view-detail', goods.id)"
      >
        <div class="aspect-square overflow-hidden">
          <img :src="goods.imageUrl" :alt="goods.name" class="w-full h-full object-cover hover:scale-105 transition-transform duration-300">
        </div>
        <div class="p-3">
          <p class="text-sm font-medium text-gray-800 truncate">{{ goods.name }}</p>
          <p v-if="goods.model" class="text-xs text-gray-500 mt-1">Model: {{ goods.model }}</p>
          <button
            class="mt-2 w-full py-2 bg-primary hover:bg-primary-dark text-white text-sm rounded transition-colors min-h-[44px]"
            @click.stop="$emit('view-inquiry', goods.id)"
          >Inquiry</button>
        </div>
      </div>
    </div>

    <div v-if="products.length === 0" class="text-center py-12 text-gray-400">
      <p>No products found in this category</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    products: { type: Array, required: true }
  },
  emits: ['view-detail', 'view-inquiry']
}
</script>
